import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-GitPullRequestDraft",
  "use": "icon-GitPullRequestDraft-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-GitPullRequestDraft\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6\" cy=\"18\" r=\"2\" /><circle cx=\"6\" cy=\"6\" r=\"2\" /><circle cx=\"18\" cy=\"18\" r=\"2\" /><path d=\"M6 8v8\" /><path d=\"M18 11h.01\" /><path d=\"M18 6h.01\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol